angular.module('TetherApp').controller('KeywordToolbarController', [
    '$window',
    'keywordService',
    function (
        $window,
        keywordService
    ) {
        let self = this;
        self.withTrashed = false;
    }
]);
